<div class="view-content">
  @if (success) {
    <div class="view-section success">
      <app-animated-check></app-animated-check>
      <p>{{ 'jobboard.views.unsubscribe.success' | transloco }}</p>
    </div>
  } @else {
    <div class="view-section">
      <div class="row">
        <div class="col-12 col-md-4 image">
          <img src="./assets/img/talentpool-email.png" />
        </div>
        <div class="col-12 col-md-8 info ps-0 ps-md-5">
          <h4 [innerHTML]="'jobboard.views.unsubscribe.title' | transloco"></h4>
          <p class="mb-3" [innerHTML]="'jobboard.views.unsubscribe.question' | transloco"></p>
          @for (channel of reminderChannels; track $index) {
            <div class="form-group col-12">
              <h6>
                <b>{{ channel.name + '.title' | transloco }}</b>
              </h6>
              <div class="d-flex align-items-center">
                <input class="m-0" type="checkbox" [id]="'channel' + $index" [(ngModel)]="channel.unsubscribe" />
                <label [for]="'channel' + $index">
                  {{ channel.name + '.checkbox' | transloco }}
                </label>
              </div>
            </div>
          }
          <button
            class="ct-btn ct-btn-themed-solid"
            [disabled]="!hasSelectedChannel()"
            (click)="submitUnsubscribeForm()"
          >
            {{ 'jobboard.views.unsubscribe.button' | transloco }}
          </button>
        </div>
      </div>
    </div>
  }
</div>
